import { DotIcon } from '@curology/ui-components-web/react/Icon/icons/DotIcon';
import { List } from '@curology/ui-components-web/react/List';
import { ListItem } from '@curology/ui-components-web/react/List/ListItem';
import { Modal } from '@curology/ui-components-web/react/Modal';
import { ModalContent } from '@curology/ui-components-web/react/Modal/ModalContent';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

export const PhotoIdModal = ({
  setShowPhotoIdModal,
  showPhotoIdModal,
}: {
  setShowPhotoIdModal: React.Dispatch<React.SetStateAction<boolean>>;
  showPhotoIdModal: boolean;
}) => {
  return (
    <Modal
      onClose={() => setShowPhotoIdModal(false)}
      open={showPhotoIdModal}
      title="What kind of ID can I use?"
      type="light"
    >
      <ModalContent>
        <Typography>
          Any government-issued photo ID with your date of birth works,
          including:
        </Typography>
        <List className="cur-mb-4" size="sm">
          <ListItem iconStart={DotIcon} title="Driver's license" />
          <ListItem iconStart={DotIcon} title="Passport" />
          <ListItem
            iconStart={DotIcon}
            title="State-issued identification card"
          />
        </List>
        <Typography className="cur-my-4">
          Make sure that your ID is uncovered, and that the picture isn&apos;t
          blurry—we need to see your information clearly! Sorry, we don&apos;t
          accept school, work, or gym IDs; yearbook photos; or Costco cards.
        </Typography>
        <Typography className="cur-my-4" weight="bold">
          Your ID is in expert hands
        </Typography>
        <Typography className="cur-mt-4">
          Your provider&apos;s, to be exact. They just need to make sure
          you&apos;re really you—just like an in-person doctor&apos;s office.
          We&apos;ll never share your personal information.
        </Typography>
      </ModalContent>
    </Modal>
  );
};
